import { useTranslation } from 'react-i18next';

import type { DraftOrderStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<DraftOrderStatus, string> = {
  draft: 'border-border text-foreground',
  invoice_sent: 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  completed: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  cancelled: 'border-border text-muted-foreground',
};

/** Invoice sent is the loud one: the shopper has the quote and staff wait on payment. */
export function DraftOrderStatusBadge({
  status,
  className,
}: {
  status: DraftOrderStatus;
  className?: string;
}) {
  const { t } = useTranslation('draftOrders');
  return (
    <Badge variant="outline" className={cn(TONE[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
